"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import * as _utils from "./utils";
import _styles from "./BlackFridayLogos.module.css";

const _interactionsData = JSON.parse(
  '{"events":{"e-670":{"id":"e-670","name":"","animationType":"preset","eventTypeId":"SCROLLING_IN_VIEW","action":{"id":"","actionTypeId":"GENERAL_CONTINUOUS_ACTION","config":{"actionListId":"a-31","affectedElements":{},"duration":0}},"mediaQueries":["main"],"target":{"id":"fb40f9a2-ac30-50ae-bf75-ae694b079af4","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"fb40f9a2-ac30-50ae-bf75-ae694b079af4","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":[{"continuousParameterGroupId":"a-31-p","smoothing":50,"startsEntering":true,"addStartOffset":false,"addOffsetValue":50,"startsExiting":false,"addEndOffset":false,"endOffsetValue":50}],"createdOn":1732304309337},"e-671":{"id":"e-671","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-672"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"fb40f9a2-ac30-50ae-bf75-ae694b079af9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"fb40f9a2-ac30-50ae-bf75-ae694b079af9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":100,"direction":"BOTTOM","effectIn":true},"createdOn":1732304309337},"e-673":{"id":"e-673","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-674"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"fb40f9a2-ac30-50ae-bf75-ae694b079afb","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"fb40f9a2-ac30-50ae-bf75-ae694b079afb","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":200,"direction":"BOTTOM","effectIn":true},"createdOn":1732304309337}},"actionLists":{"a-31":{"id":"a-31","title":"alberta_features-scroll 4","continuousParameterGroups":[{"id":"a-31-p","type":"SCROLL_PROGRESS","parameterLabel":"Scroll","continuousActionGroups":[{"keyframe":58,"actionItems":[{"id":"a-31-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".alberta_features-img._1","selectorGuids":["daec58b2-0eb6-8d61-459e-83d249a53e78","daec58b2-0eb6-8d61-459e-83d249a53e82"]},"value":1,"unit":""}}]},{"keyframe":68,"actionItems":[{"id":"a-31-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".alberta_features-img._1","selectorGuids":["daec58b2-0eb6-8d61-459e-83d249a53e78","daec58b2-0eb6-8d61-459e-83d249a53e82"]},"value":0,"unit":""}}]},{"keyframe":72,"actionItems":[{"id":"a-31-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".alberta_features-img._2","selectorGuids":["daec58b2-0eb6-8d61-459e-83d249a53e78","daec58b2-0eb6-8d61-459e-83d249a53e83"]},"value":1,"unit":""}}]},{"keyframe":78,"actionItems":[{"id":"a-31-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".alberta_features-img._2","selectorGuids":["daec58b2-0eb6-8d61-459e-83d249a53e78","daec58b2-0eb6-8d61-459e-83d249a53e83"]},"value":0,"unit":""}}]}]}],"createdOn":1715726893642},"slideInBottom":{"id":"slideInBottom","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":100,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}},{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}}]}]}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function BlackFridayLogos({ as: _Component = _Builtin.Section }) {
  _interactions.useInteractions(_interactionsData, _styles);

  return (
    <_Component
      className={_utils.cx(_styles, "blackfriday_section-logos")}
      data-w-id="fb40f9a2-ac30-50ae-bf75-ae694b079af4"
      tag="section"
      grid={{
        type: "section",
      }}
    >
      <_Builtin.Block
        className={_utils.cx(_styles, "container-large")}
        tag="div"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "padding-section-small")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "padding-global")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(
                _styles,
                "blackfriday_features-container-copy",
                "max-width-xxlarge",
                "align-center"
              )}
              tag="div"
            >
              <_Builtin.Paragraph
                className={_utils.cx(
                  _styles,
                  "heading-style-h6",
                  "text-color-secondary",
                  "align-center"
                )}
                data-w-id="fb40f9a2-ac30-50ae-bf75-ae694b079af9"
              >
                {
                  "Trusted by OVER 10,000 Landlords and Property Managers Across Canada"
                }
              </_Builtin.Paragraph>
              <_Builtin.Block
                className={_utils.cx(_styles, "blackfriday_logos-grid")}
                data-w-id="fb40f9a2-ac30-50ae-bf75-ae694b079afb"
                tag="div"
              >
                <_Builtin.Image
                  className={_utils.cx(_styles, "blackfriday_logo-image")}
                  id={_utils.cx(
                    _styles,
                    "w-node-fb40f9a2-ac30-50ae-bf75-ae694b079afc-4b079af4"
                  )}
                  width="auto"
                  height="160"
                  loading="lazy"
                  alt=""
                  src="https://cdn.prod.website-files.com/64d3f7fe1cc4f17b36a7a5ef/6734d893b7dcef5cea7ffe18_Sterling2.webp"
                />
                <_Builtin.Image
                  className={_utils.cx(_styles, "blackfriday_logo-image")}
                  id={_utils.cx(
                    _styles,
                    "w-node-fb40f9a2-ac30-50ae-bf75-ae694b079afd-4b079af4"
                  )}
                  width="auto"
                  height="140"
                  loading="lazy"
                  alt=""
                  src="https://cdn.prod.website-files.com/64d3f7fe1cc4f17b36a7a5ef/6734d8ba02f46d8dfd75df13_Mainstreet2.webp"
                />
                <_Builtin.Image
                  className={_utils.cx(_styles, "blackfriday_logo-image")}
                  id={_utils.cx(
                    _styles,
                    "w-node-fb40f9a2-ac30-50ae-bf75-ae694b079afe-4b079af4"
                  )}
                  width="Auto"
                  height="80"
                  loading="lazy"
                  alt=""
                  src="https://cdn.prod.website-files.com/64d3f7fe1cc4f17b36a7a5ef/6734d8ed0b64d8dfd6ba7d81_Greenwin2.webp"
                />
                <_Builtin.Image
                  className={_utils.cx(_styles, "blackfriday_logo-image")}
                  id={_utils.cx(
                    _styles,
                    "w-node-fb40f9a2-ac30-50ae-bf75-ae694b079aff-4b079af4"
                  )}
                  width="auto"
                  height="120"
                  loading="lazy"
                  alt=""
                  src="https://cdn.prod.website-files.com/64d3f7fe1cc4f17b36a7a5ef/6734d9449187f0d58c968b43_Centurion%202.webp"
                />
                <_Builtin.Image
                  className={_utils.cx(_styles, "blackfriday_logo-image")}
                  id={_utils.cx(
                    _styles,
                    "w-node-fb40f9a2-ac30-50ae-bf75-ae694b079b00-4b079af4"
                  )}
                  width="Auto"
                  height="100"
                  loading="lazy"
                  alt=""
                  src="https://cdn.prod.website-files.com/64d3f7fe1cc4f17b36a7a5ef/6734dc63d46dda7cd0a22d59_MetCap3.webp"
                />
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
